import { mapState } from 'vuex';

/**
 * Mixin zarządzania modalem podglądu
 *
 * @export
 * @param {*} moduleName
 * @returns
 */
export function previewManageMixin(moduleName) {
  return {
    props: {
      // Boolean kontrolujący widoczność modala
      show: {
        type: Boolean,
        required: true,
        default: false
      }
    },
    methods: {
      // @vuese
      // Funkcja emituje event `close` do zamknięcia modalu
      close() {
        // Zamyka modal
        this.$emit('close');
      }
    },
    computed: mapState({
      stateData: state => state[moduleName].data
    })
  };
}
